import { useEffect } from 'react'

import { Outlet, useLoaderData, useLocation } from 'react-router-dom'

import SuspendedLayout from '../../SuspendedLayout'

import FrontFooter from '../Navigation/FrontFooter'

import request from '../Functions/ajax/request'

import RolesStore from '../../Stores/Roles'

import setRolesStore from '../../StoresFunctions/setRolesStore'
import FrontHeader from '../Navigation/FrontHeader.jsx'
import BottomMenu from '../BottomMenu.jsx'

export default function FrontLayout ()
{
	const { page } = useLoaderData();

	const location = useLocation();

	const { pathname } = location;

	const roles_status = RolesStore.useState(s => s.status);

	useEffect(() =>
	{
		if (roles_status !== 'pending') return;

		const controller = new AbortController();

		(async function fetchRoles ()
		{
			try
			{
				var { roles, user_id } = await request('/auth/get-roles')
				.config({ controller })
				.post();
			}
			catch (update)
			{
				return;
			}

			setRolesStore({ roles, user_id });
		})();

		return () => controller?.abort?.();
	},
	[roles_status]);

	useEffect(function ()
	{
		window.scrollTo(0, 0);
	},
	[pathname]);

	return (
		<SuspendedLayout resolve={ page }>

			<div className="front-page">
				<FrontHeader />
				<Outlet />
				
				<FrontFooter layout="PompesF" />
			</div>

		</SuspendedLayout>
	);
}